module["exports"] = [
  "кв. ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/secondary_address.js
// module id = 1998
// module chunks = 0